import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Car, Loader2, UserPlus } from "lucide-react";

export default function Register() {
  const navigate = useNavigate();
  const { applyAuth } = useAuth();
  const [f, setF] = useState({ name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/register", f);
      applyAuth(data);
      toast.success("Conta criada! Bem-vindo ao PicCar.");
      navigate("/painel");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  const google = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/painel";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen grid grid-cols-1 lg:grid-cols-2">
      <div className="hidden lg:flex relative bg-obsidian text-white p-12 flex-col justify-between overflow-hidden">
        <img src="https://images.unsplash.com/photo-1612805144400-88c7821bf36f" alt="" className="absolute inset-0 w-full h-full object-cover opacity-25" />
        <div className="relative z-10 flex items-center gap-2">
          <span className="w-9 h-9 rounded-sm bg-white/10 flex items-center justify-center"><Car className="w-5 h-5 text-blaze" /></span>
          <span className="font-heading font-800 text-xl">Pic<span className="text-blaze">Car</span></span>
        </div>
        <div className="relative z-10">
          <h2 className="font-heading font-900 text-4xl leading-tight">Comece a vender<br />em minutos.</h2>
          <p className="mt-4 text-white/60 max-w-sm">Anúncio gratuito, sem limite de fotos. Você só paga o cartaz VENDE-SE se quiser.</p>
        </div>
      </div>

      <div className="flex items-center justify-center p-6 sm:p-12" data-testid="register-page">
        <div className="w-full max-w-sm">
          <Link to="/" className="lg:hidden flex items-center gap-2 mb-8">
            <span className="w-9 h-9 rounded-sm bg-obsidian flex items-center justify-center"><Car className="w-5 h-5 text-blaze" /></span>
            <span className="font-heading font-800 text-xl">Pic<span className="text-blaze">Car</span></span>
          </Link>
          <p className="overline text-blaze mb-2">Criar conta</p>
          <h1 className="font-heading font-800 text-3xl mb-8">Cadastre-se grátis</h1>

          <Button variant="outline" className="w-full h-12 rounded-sm border-obsidian/15 font-600 mb-6" onClick={google} data-testid="google-register-btn">
            <img src="https://www.google.com/favicon.ico" alt="" className="w-4 h-4 mr-2" /> Continuar com Google
          </Button>
          <div className="flex items-center gap-3 mb-6">
            <div className="flex-1 h-px bg-border" /><span className="text-xs text-muted-foreground">ou</span><div className="flex-1 h-px bg-border" />
          </div>

          <form onSubmit={submit} className="space-y-4">
            <div><Label>Nome completo</Label><Input value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} className="mt-2 rounded-sm h-11" required data-testid="register-name" /></div>
            <div><Label>E-mail</Label><Input type="email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} className="mt-2 rounded-sm h-11" required data-testid="register-email" /></div>
            <div><Label>Senha</Label><Input type="password" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} className="mt-2 rounded-sm h-11" required minLength={6} data-testid="register-password" /></div>
            <Button type="submit" disabled={loading} className="w-full h-12 bg-obsidian hover:bg-blaze text-white font-700 rounded-sm" data-testid="register-submit">
              {loading ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <UserPlus className="w-4 h-4 mr-2" />} Criar conta grátis
            </Button>
          </form>

          <p className="mt-6 text-sm text-muted-foreground text-center">
            Já tem conta? <Link to="/entrar" className="font-700 text-obsidian hover:text-blaze" data-testid="to-login">Entrar</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
